import { API } from "services/enum/api";
import { fetcher } from "services/fetcher";
import useSWR from "swr";

export interface IndustryWithCompanies extends Industry {
  companies: Company[];
}

type UseCompaniesReturnType = {
  isLoading: boolean;
  data: IndustryWithCompanies[];
  mutate: () => void;
  isValidating: boolean;
  error: any;
  isEmpty: boolean;
  isError: any;
  [key: string]: any;
};

export function useCompanies(): UseCompaniesReturnType {
  const { data, mutate, error, isLoading, isValidating } = useSWR(API.COMPANIES_BY_INDUSTRY, fetcher);
  const industries = data?.data || [];
  const industriesWithCompanies = industries.map((industry: IndustryWithCompanies) => ({
    ...industry,
    companyCount: industry.companies.length,
  }));

  return {
    data: industriesWithCompanies,
    isLoading,
    isError: error,
    isEmpty: !error && !isLoading && !data,
    mutate,
    isValidating,
    error,
  }
};